import React from 'react';
import { Link } from 'react-router-dom';
import { useAuthContext } from '../contexts/AuthContext';

const Header: React.FC = () => {
  const {
    user,
    signOut,
    connectWallet,
    loginWithWallet,
    address,
    isWalletConnected,
    error,
    disconnectWallet
  } = useAuthContext();


  return (
        <header className="header">
      <div className="header-content">
        <div className="logo">
          <img src="/path-to-your-logo.png" alt="Weirdly.fuN" />
          <span className="beta-tag">Beta</span>
        </div>
        <nav>
          <ul>
            <li><Link to="/" className="active">Home</Link></li>
            <li><Link to="/add">Add a Game</Link></li>
            <li><Link to="/launching">Launching Soon</Link></li>
            <li><Link to="/leaderboards">Leaderboards</Link></li>
            <li><a href="https://docs.weirdly.fun/" target="_blank" rel="noopener noreferrer">Docs</a></li>
            <li><a href="https://x.com/WeirdlyFunApp" target="_blank" rel="noopener noreferrer">Twitter</a></li>
            <li><a href="https://t.me/+2EL3buZGEHE3YTZh" target="_blank" rel="noopener noreferrer">Telegram</a></li>
          </ul>
        </nav>
        <div className="auth-section">
          {error && <p className="error-message">{error}</p>}
          {!isWalletConnected && !user  && (
            <button className="btn btn-connect" onClick={connectWallet}>Connect Wallet</button>
          )}
          {isWalletConnected && !user && (
            <>
              <p>Connected address: {address}</p>
              <button className="btn btn-connect" onClick={loginWithWallet}>Login</button>
              <button className="btn btn-disconnect" onClick={disconnectWallet}>Disconnect Wallet</button>
            </>
          )}
          {user && (
            <>
              {/* <p>Welcome, {user.username}</p> */}
              <button className="btn btn-connect" onClick={signOut}>Sign Out</button>
            </>
          )}
        </div>
      </div>
    </header>
  );
}

export default Header;